<template>
  <div>
    <div class="auth-section">
      <!-- FULL BACKGROUND IMAGE -->
      <div class="auth-frame">
        <img
          v-lazy="localImg('InviteBg.png')"
          class="invite-img"
          v-if="show_invitation_bg"
        />
        <img
          v-lazy="
            school_banner ? school_banner : localImg('helpFooterBlob.svg')
          "
          class="base-img"
          v-else
        />

        <!-- CUSTOM OVERLAY  -->
        <div class="custom-overlay" v-if="is_custom"></div>
      </div>

      <!-- CLOSE DIALOG -->
      <div class="pageClose dialogDismiss">
        <router-link
          :to="{ name: 'GradelySignupLander' }"
          class="close_dialog cls_lg transparent_bg"
        ></router-link>
      </div>

      <!-- AUTHENTICATION FORM DISPLAY SECTION -->
      <main class="auth-section-block">
        <div class="container">
          <div class="row d-flex justify-content-center">
            <div :class="show_invitation_bg ? 'col-md-6' : 'col-md-4'">
              <!-- LOGO IMAGE HOLDER -->
              <div
                class="logo-holder d-flex"
                :class="{ 'justify-content-center': !left_align }"
              >
                <router-link to class="w-auto">
                  <img
                    class="custom-img"
                    v-lazy="school_logo"
                    :alt="school_name"
                    v-if="custom_image"
                  />
                  <img
                    class="gradely-img"
                    v-lazy="localImg('Gradely.svg')"
                    alt="Gradely.ng"
                    v-else
                  />
                </router-link>
              </div>
              <!-- LOGO IMAGE HOLDER -->

              <slot name="auth_form_block"></slot>
            </div>
          </div>
        </div>
      </main>

      <!-- AUTH FOOTER -->
      <AuthFooter />
      <!-- AUTH FOOTER -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AuthFooter from "@/components/globalComps/AuthComps/AuthFooter";

export default {
  name: "AuthContainer",

  components: {
    AuthFooter,
  },

  props: {
    left_align: {
      type: Boolean,
      default: false,
    },

    show_invitation_bg: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.getDisplayLogo();
  },

  data() {
    return {
      custom_image: false,
      school_logo: "Gradely.svg",
      school_name: "Gradely.ng",
      school_banner: null,

      is_custom: this.$route.query.school,
    };
  },

  methods: {
    ...mapActions(["getSchoolLogo"]),

    getDisplayLogo() {
      let page_type = this.$route.path.split("/")[1];

      if (page_type === "login") {
        if (this.$route.query.school) {
          this.getSchoolLogo(this.$route.query.school)
            .then((response) => {
              console.log(response);
              this.school_logo = response.data.logo;
              this.school_name = response.data.name;
              this.school_banner = response.data.wallpaper;
              this.custom_image = this.school_logo ? true : false;
            })
            .catch((err) => console.log(err));
        }
      }
    },
  },
};
</script>

<style lang="scss">
.auth-section {
  .auth-frame {
    .base-img {
      @include fixed_full_section();
      object-fit: cover;
    }
    .invite-img {
      @include fixed_full_section();
      height: auto;
      // object-fit: cover;
    }

    .custom-overlay {
      @include fixed_full_section;
      background: rgba(44, 44, 44, 0.693);
    }
  }

  .auth-section-block {
    padding: 70px 0px;

    @include breakpoint_max(sm) {
      padding: 60px 0px;
    }
  }

  .logo-holder {
    .gradely-img {
      @include custom_min_edge(190, 62);

      @include breakpoint_max(sm) {
        @include custom_min_edge(165, 52);
      }
    }

    .custom-img {
      min-width: 100px;
      width: auto;
      max-width: 130px;
      height: auto;
    }
  }

  .auth-form-block {
    margin-top: 40px;
  }
}

.auth-block-header {
  margin-bottom: 20px;

  .title,
  .sub-title {
    font-size: 32px;
    letter-spacing: 0.04rem;

    @include breakpoint_max(sm) {
      font-size: 22px;
    }
  }
  .sub-title {
    font-size: 20px;

    @include breakpoint_max(sm) {
      font-size: 18px;
    }
  }

  .info-text {
    font-size: 14px;
    line-height: 180%;

    @include breakpoint_max(sm) {
      font-size: 13.5px;
    }
  }
}

.auth-form {
  margin-top: 50px;

  span {
    .icon_eye {
      @include equal_min_edge(20);
    }
  }

  .disclaimer-block {
    margin-top: 18px;
    font-size: 14px;
  }

  .auth-cta {
    margin-top: 22px;
    .btn {
      padding: 15px 32px;
      min-width: 260px;

      @include breakpoint_max(sm) {
        padding: 13px 32px;
        min-width: 80%;
      }

      @include breakpoint_max(xs) {
        min-width: 100%;
      }
    }
  }
}
</style>
